import { useAllowFeature } from "@hooks/useAllowFeature";
import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { ClassesSettings } from "./ClassesSettings";
import { ClassesPaywalled } from "./ClassesPaywalled";

export const ClassesPage: React.FC = () => {
    const { hasAccess, isFetched } = useAllowFeature(PREMIUM_FEATURES.CLASSES);

    if (!isFetched) {
        return null;
    }

    if (!hasAccess) {
        return <ClassesPaywalled />;
    }

    return <ClassesSettings />;
};
